// Rougly based on: https://github.com/dgenzer/suricata-highlight-vscode/blob/master/grammars/suricata.tmLanguage
import { languages } from 'monaco-editor';

export const suricataTokenizer: languages.IMonarchLanguage = {
  keywords: [
    'pass',
    'drop',
    'reject',
    'alert',
    'any',
    'msg',
    'sid',
    'rev',
    'gid',
    'classtype',
    'reference',
    'priority',
    'metadata',
    'target',
    'pcre',
    'ttl',
    'ipopts',
    'sameip',
    'ip_proto',
    'id',
    'geoip',
    'fragbits',
    'fragoffset',
    'tos',
    'seq',
    'ack',
    'window',
    'itype',
    'icode',
    'icmp_id',
    'icmp_seq',
    'content',
    'nocase',
    'depth',
    'startswith',
    'offset',
    'distance',
    'within',
    'isdataat',
    'dsize',
    'rpc',
    'replace',
    'byte_test',
    'byte_jump',
    'byte_extract',
    'dotprefix',
    'strip_whitespace',
    'compress_whitespace',
    'to_sha256',
    'to_md5',
    'to_sha1',
    'pcrexform',
    'url_decode',
    'fast_pattern',
    'prefilter',
    'flowbits',
    'flowint',
    'flow',
    'stream_size',
    'bypass',
    'http_raw_uri',
    'http_client_body',
    'http_raw_header',
    'http_cookie',
    'http_raw_host',
    'http_server_body',
    'filename',
    'fileext',
    'filemagic',
    'filestore',
    'filemd5',
    'filesha1',
    'filesha256',
    'filesize',
    'dns_query',
    'tls_cert_notbefore',
    'tls_cert_notafter',
    'tls_cert_expired',
    'tls_cert_valid',
    'ssl_version',
    'ssl_state',
    'tls_cert_subject',
    'tls_cert_issuer',
    'tls_cert_serial',
    'tls_cert_fingerprint',
    'tls_sni',
    'ssh_proto',
    'ssh_software',
    'ja3_hash',
    'ja3_string',
    'dnp3_func',
    'dnp3_ind',
    'dnp3_obj',
    'dnp3_data',
    'enip_command',
    'cip_service',
    'ftpdata_command',
    'ftpbounce',
    'krb5_msg_type',
    'krb5_err_code',
    'krb5_cname',
    'krb5_sname',
    'xbits',
    'threshold',
    'detection_filter',
    'tcp',
    'udp',
    'icmp',
    'ip',
    'http',
    'ftp',
    'tls',
    'smb',
    'dns',
    'dcerpc',
    'ssh',
    'smtp',
    'imap',
    'msn',
    'modbus',
    'dnp3',
    'enip',
    'nfs',
    'ikev2',
    'krb5',
    'ntp',
    'dhcp',
    'sip',
    'snmp',
  ],
  symbols: /[=><!~?:&|+\-*/^%]+/,
  escapes:
    /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
  tokenizer: {
    root: [
      [
        /@?[a-zA-Z][\w$]*/,
        {
          cases: {
            '@keywords': 'keyword',
            '@default': 'variable',
          },
        },
      ],
      [/".*?"/, 'string'],
    ],
  },
};
